module.exports = __webpack_public_path__ + "static/media/17_burgerking.54470841.svg";